import React from 'react';
//import PropTypes from 'prop-types';
import {
  Menu,
  Dropdown,
  Icon,
  Label,
  Segment,
  Image,
  Button,
} from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { logOutUser } from 'Common/Security/SecurityHelpers';
import { logOutAction } from 'Common/Security/state/actions';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { resetDirty } from 'State/dirtyTracking/actions';
import {
  removeNotification,
  removeNotificationsByUser,
} from 'Common/UI/state/actions';
import { PENDO_ICON } from 'Common/Constants';

import 'Styles/components/controls.less';

class AppHeaderControlsContainer extends React.Component {
  state = {
    showYesNoConfirm: false,
    yesCallback: null,
    showNotifications: false,
    resourceCenterOpen: false,
  };

  profileYesCallback = () => {
    this.props.history.push(`/userprofile`);
  };

  logoutYesCallback = () => {
    this.props.logOutAction();
    logOutUser(this.props.history, false);
  };

  dropdownItemClicked = (e, yesCallback) => {
    if (this.props.getPageLevelDirty()) {
      e.preventDefault();
      this.setState({
        showYesNoConfirm: true,
        yesCallback,
      });
    } else {
      yesCallback();
    }
  };

  removeNotification = (id) => (e) => {
    e.stopPropagation();
    this.props.removeNotification(id);
  };

  renderNotification = (notification) => {
    return (
      <Segment
        className={`notification-item ${notification.Path ? '' : 'no-link'}`}
        onClick={() => {
          if (notification && notification.Path) {
            const path =
              notification.Path.charAt(0) === '/'
                ? notification.Path
                : `/${notification.Path}`;
            this.setState({ showNotifications: false });
            this.props.history.push(`${path}`);
          }
        }}
      >
        <div className={'notification-title'} title={notification.Title}>
          {notification.Title}
          <span className={'notification-date'}>
            {moment(notification.SentDT).format('MM/DD/YY hh:mm A')}
          </span>
          <Icon
            onClick={this.removeNotification(notification.Id)}
            name="cancel"
            title={'Dismiss'}
          />
        </div>
        <span title={notification.Description}>{notification.Description}</span>
      </Segment>
    );
  };

  renderDismissAll = () => {
    return (
      <Segment
        className={'notification-dismiss-all'}
        onClick={this.removeAllNotifications}
      >
        Dismiss All Notifications
      </Segment>
    );
  };

  removeAllNotifications = () => {
    this.setState({ showNotifications: false });
    this.props.removeNotificationsByUser();
  };

  handleResourceCenterClick = () => {
    this.setState({ resourceCenterOpen: !this.state.resourceCenterOpen });
  };

  render() {
    const trigger = (
      <span>
        <Icon name="user" size="small" />
        {this.props.userInfo.userName}
      </span>
    );
    let notifications = this.props.notifications
      ? this.props.notifications
          .sort((a, b) => (a.SentDT > b.SentDT ? -1 : 1))
          .map((notification) => ({
            key: notification.Id,
            text: this.renderNotification(notification),
            selected: false,
            active: true,
          }))
      : [];

    if (notifications.length) {
      notifications = notifications.concat({
        key: -1,
        text: this.renderDismissAll(),
        selected: false,
        active: true,
      });
    }
    const alerts = (
      <span>
        {this.props.notifications.length ? (
          <Label
            size={'small'}
            className={'notification-count'}
            floating
            color="orange"
          >
            {this.props.notifications.length}
          </Label>
        ) : null}
      </span>
    );

    return (
      <span>
        <Menu secondary className="app-header-controls pull-right">
          <Menu.Item className="notifications">
            <Dropdown
              onClick={() =>
                this.setState({
                  showNotifications: !this.state.showNotifications,
                })
              }
              onBlur={() => this.setState({ showNotifications: false })}
              open={this.state.showNotifications}
              className={'notification-dropdown'}
              pointing={'top right'}
              trigger={alerts}
              icon={{ name: 'alarm', size: 'large' }}
              options={
                notifications.length
                  ? notifications
                  : [
                      {
                        key: 0,
                        text: <Segment>No notifications.</Segment>,
                        value: 0,
                        selected: false,
                        active: false,
                      },
                    ]
              }
            />
          </Menu.Item>
          <Menu.Item>
            <Dropdown pointing trigger={trigger}>
              <Dropdown.Menu>
                <Dropdown.Item
                  text="Your Profile"
                  onClick={(e) => {
                    this.dropdownItemClicked(e, this.profileYesCallback);
                  }}
                />
                <Dropdown.Item text="Settings" />
                <Dropdown.Item
                  text="Sign Out"
                  onClick={(e) => {
                    this.dropdownItemClicked(e, this.logoutYesCallback);
                  }}
                />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
          <Menu.Item fitted="vertically">
            <Image
              id="pendo-icon"
              ui={false}
              src={PENDO_ICON}
              onClick={this.handleResourceCenterClick}
            ></Image>
            <Dropdown open={this.state.resourceCenterOpen} icon={null} className="resource-center__dropdown">
              <Dropdown.Menu
                direction={'left'}
                className="resource-center__container"
              >
                <div
                  className="resource-center__header-container"
                  style={{ minWidth: '275px' }}
                >
                  <h2 className="resource-center__header">Resource Center</h2>
                  <Button
                    icon={{ name: 'close', size: 'large' }}
                    className="resource-center__close"
                    onClick={this.handleResourceCenterClick}
                  />
                </div>
                <div className="resource-center__list">
                  <a
                    href={
                      'https://linqhelp.mcoutput.com/mealsplusweb/Content/MPW.htm'
                    }
                    target="_blank" rel="noreferrer noopener"
                  >
                    <div className="resource-center__link">
                      <div className="resource-center__link__text">
                        Documentation
                      </div>
                      <div className="resource-center__link__sub-text">
                        Link to Help Files
                      </div>
                      <Icon
                        name="chevron right"
                        className="resource-center__chevron"
                      />
                    </div>
                  </a>
                  <a
                    href={
                      'https://linqhelp.mcoutput.com/mealsplusweb/Content/Release%20Notes/Release%20Notes.htm'
                    }
                    target="_blank" rel="noreferrer noopener"
                  >
                    <div className="resource-center__link">
                      <div className="resource-center__link__text">
                        Release Notes
                      </div>
                      <Icon
                        name="chevron right"
                        className="resource-center__chevron"
                      />
                    </div>
                  </a>
                  <a href={'http://www.gotoassist.com/ph/mealsplus/'} target="_blank" rel="noreferrer noopener">
                    <div className="resource-center__link">
                      <div className="resource-center__link__text">
                        Remote Support
                      </div>
                      <div className="resource-center__link__sub-text">
                        Link to GOTO Assist
                      </div>
                      <Icon
                        name="chevron right"
                        className="resource-center__chevron"
                      />
                    </div>
                  </a>
                  <a
                    href={
                      'https://www.linq.com/wp-content/uploads/2020/08/K12PC_Privacy_Policy.pdf'
                    }
                    target="_blank" rel="noreferrer noopener"
                  >
                    <div className="resource-center__link">
                      <div className="resource-center__link__text">
                        Privacy Policy
                      </div>
                      <Icon
                        name="chevron right"
                        className="resource-center__chevron"
                      />
                    </div>
                  </a>
                  <a
                    href={
                      'https://www.linq.com/wp-content/uploads/2020/08/EMS_LINQ_TC.pdf'
                    }
                    target="_blank" rel="noreferrer noopener"
                  >
                    <div className="resource-center__link">
                      <div className="resource-center__link__text">
                        Terms of Use
                      </div>
                      <Icon
                        name="chevron right"
                        className="resource-center__chevron"
                      />
                    </div>
                  </a>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu>
        <YesNoDialog
          isSavePrompt={true}
          showDialog={this.state.showYesNoConfirm}
          yesCallback={() => {
            this.props.resetDirty();
            this.setState({ showYesNoConfirm: false });
            this.state.yesCallback();
          }}
          noCallback={() => {
            this.setState({ showYesNoConfirm: false });
          }}
        />
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.SecurityState.userInfo,
    notifications: state.GlobalUIState.notifications,
  };
};

export const AppHeaderControls = withRouter(
  connect(mapStateToProps, {
    logOutAction,
    resetDirty,
    removeNotification,
    removeNotificationsByUser,
  })(AppHeaderControlsContainer)
);



// WEBPACK FOOTER //
// ./src/components/app/header/Controls.js